import React, { useState } from 'react';
import axios from 'axios';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import colors from '~/assets/colors.module.scss';
import Button from '~/components/core/Atomic/Buttons/Button';
import { PlusIcon } from '~/components/icons';
import UpsertRoleDialog from '~/components/SystemConfiguration/ContactRoles/UpsertRoleDialog';
import { useSysconfig } from '~/components/SystemConfiguration/SystemConfigurationScreen';
import { reportAxiosError } from '~/Utils';

interface AddRoleButtonProps {
  className?: string;
}

const AddRoleButton: React.FC<AddRoleButtonProps> = ({ className }) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { organization } = useSysconfig();

  const [isAddRoleDialogIsOpen, setIsAddRoleDialogIsOpen] = useState(false);

  const handleSubmit = async (values: Record<string, unknown>) => {
    try {
      await axios.post(`/sysconfig/api/v1/organizations/${organization.id}/contact_roles`, values);
    } catch (error) {
      await reportAxiosError(error);
      throw error;
    }
  };

  return (
    <>
      <Button
        className={`${className} text-teal-700`}
        onClick={() => setIsAddRoleDialogIsOpen(true)}
        startIcon={<PlusIcon iconColor={colors.buttonLink} size={14} />}
      >
        Add Contact Role
      </Button>
      {isAddRoleDialogIsOpen ? (
        <UpsertRoleDialog onSubmit={handleSubmit} onClose={() => setIsAddRoleDialogIsOpen(false)} />
      ) : null}
    </>
  );
};

export default AddRoleButton;
